import { type ReactElement, type ReactNode } from 'react';
import Button from '../../../Button';
import { CheckIcon } from '../../../icons/CheckIcon';
import { TargetIcon } from '../../../icons/TargetIcon';
import Typography from '../../../Typography';
import { StyledGridCopilotActionCardContent, StyledGridCopilotActionCardHighlightAction, StyledGridCopilotThinkingActionCard } from '../styles';
export interface CopilotActionCardProps {
  label: ReactNode;
  detail?: ReactNode;
  icon?: ReactNode;
  onHighlight?: () => void;
  highlightAriaLabel?: string;
}
const CopilotActionCard = ({
  label,
  detail,
  icon = <CheckIcon />,
  onHighlight,
  highlightAriaLabel = 'Highlight related page element'
}: CopilotActionCardProps): ReactElement => {
  return <StyledGridCopilotThinkingActionCard>
      <StyledGridCopilotActionCardContent>
        {icon}
        <Typography variant="body3">{label}</Typography>
        {detail}
      </StyledGridCopilotActionCardContent>
      {onHighlight == null ? null : <StyledGridCopilotActionCardHighlightAction>
          <Button variant="text" size="small" aria-label={highlightAriaLabel} leftIcon={<TargetIcon />} onClick={onHighlight} />
        </StyledGridCopilotActionCardHighlightAction>}
    </StyledGridCopilotThinkingActionCard>;
};
export default CopilotActionCard;
export { CopilotActionCard };